/* v4.64 (Greta 2026-10-21): UGC video strip on the PDP (main-product block ugc_videos). */
(function () {
  function init(root) {
    if (root.__kkUgc) return; root.__kkUgc = true;
    var track = root.querySelector('[data-kk-ugc-track]');
    var prev = root.querySelector('[data-kk-ugc-prev]'), next = root.querySelector('[data-kk-ugc-next]');
    function step() { var c = track.querySelector('.kk-ugc__card'); return c ? c.getBoundingClientRect().width + 12 : track.clientWidth; }
    function sync() {
      if (!prev) return;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', sync, { passive: true }); sync();
    var vids = root.querySelectorAll('video');
    var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting && e.intersectionRatio > 0.6 && root.open) { v.preload = 'auto'; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else { v.pause(); }
      });
    }, { threshold: [0, 0.6, 1] }) : null;
    vids.forEach(function (v) { v.muted = true; v.removeAttribute('controls'); if (io) io.observe(v); });
    /* v4.65: posters load only shortly before the strip is reached */
    function poster(v) { if (v.dataset.poster && !v.poster) v.poster = v.dataset.poster; }
    if ('IntersectionObserver' in window) {
      var pio = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { poster(e.target); pio.unobserve(e.target); } }); }, { rootMargin: '400px 400px' });
      vids.forEach(function (v) { pio.observe(v); });
    } else vids.forEach(poster);
    root.addEventListener('toggle', function () { if (!root.open) vids.forEach(function (v) { v.pause(); }); else if (io) vids.forEach(function (v) { io.unobserve(v); io.observe(v); }); });
    var medias = Array.prototype.slice.call(root.querySelectorAll('[data-kk-ugc-media]'));
    medias.forEach(function (m, i) {
      m.setAttribute('aria-label', 'Video vergrößern');
      function o() { openLb(root, medias, i); }
      m.addEventListener('click', o);
      m.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); o(); } });
    });
  }

  /* v4.64 (Greta 2026-10-22): click a card -> large 9:16 lightbox (Medora-style), sound on. */
  var lb, lbV, lbBar, lbCap, lbSnd, lbState = null;
  function build() {
    lb = document.createElement('div');
    lb.className = 'kk-ugcx'; lb.setAttribute('role', 'dialog'); lb.setAttribute('aria-modal', 'true'); lb.hidden = true;
    lb.innerHTML = '<div class="kk-ugcx__frame"><div class="kk-ugcx__bar"><i></i></div>' +
      '<video class="kk-ugcx__video" playsinline loop></video>' +
      '<button type="button" class="kk-ugcx__close" aria-label="Schließen"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg></button>' +
      '<button type="button" class="kk-ugcx__snd" aria-label="Ton an/aus"></button>' +
      '<span class="kk-ugcx__cap"></span></div>' +
      '<button type="button" class="kk-ugcx__nav kk-ugcx__nav--prev" aria-label="Zurück"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M15 6l-6 6 6 6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg></button>' +
      '<button type="button" class="kk-ugcx__nav kk-ugcx__nav--next" aria-label="Weiter"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M9 6l6 6-6 6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg></button>';
    document.body.appendChild(lb);
    lbV = lb.querySelector('video'); lbBar = lb.querySelector('.kk-ugcx__bar i'); lbCap = lb.querySelector('.kk-ugcx__cap'); lbSnd = lb.querySelector('.kk-ugcx__snd');
    lb.addEventListener('click', function (e) { if (e.target === lb) closeLb(); });
    lb.querySelector('.kk-ugcx__close').addEventListener('click', closeLb);
    lb.querySelector('.kk-ugcx__nav--prev').addEventListener('click', function () { go(-1); });
    lb.querySelector('.kk-ugcx__nav--next').addEventListener('click', function () { go(1); });
    lbSnd.addEventListener('click', function (e) { e.stopPropagation(); lbV.muted = !lbV.muted; sndState(); });
    lbV.addEventListener('click', function () { if (lbV.paused) play(lbV); else lbV.pause(); });
    lbV.addEventListener('timeupdate', function () { lbBar.style.width = lbV.duration ? (lbV.currentTime / lbV.duration * 100) + '%' : '0'; });
    var x0 = null;
    lb.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    lb.addEventListener('touchend', function (e) { if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; x0 = null; if (Math.abs(dx) > 50) go(dx < 0 ? 1 : -1); }, { passive: true });
    document.addEventListener('keydown', function (e) {
      if (!lbState) return;
      if (e.key === 'Escape') closeLb(); else if (e.key === 'ArrowRight') go(1); else if (e.key === 'ArrowLeft') go(-1);
    });
  }
  function play(v) { var p = v.play(); if (p && p.catch) p.catch(function () { v.muted = true; sndState(); var q = v.play(); if (q && q.catch) q.catch(function () {}); }); }
  function sndState() { lb.classList.toggle('is-muted', lbV.muted); }
  function load(i) {
    var s = lbState, m = s.medias[i], src = m.querySelector('video');
    s.i = i;
    lbV.innerHTML = ''; lbV.removeAttribute('src');
    [src.dataset.hd, src.dataset.top].forEach(function (u) { if (!u) return; var o = document.createElement('source'); o.src = u; o.type = 'video/mp4'; lbV.appendChild(o); });
    if (!lbV.children.length) Array.prototype.forEach.call(src.querySelectorAll('source'), function (o) { lbV.appendChild(o.cloneNode()); });
    lbV.poster = src.poster || src.dataset.poster || '';
    var h = m.closest('.kk-ugc__card'); h = h && h.querySelector('.kk-ugc__handle');
    lbCap.textContent = h ? h.textContent : '';
    lbBar.style.width = '0';
    lb.classList.toggle('is-single', s.medias.length < 2);
    lbV.load(); play(lbV);
  }
  function go(d) { if (!lbState || lbState.medias.length < 2) return; var n = lbState.medias.length; load((lbState.i + d + n) % n); }
  function openLb(root, medias, i) {
    if (!lb) build();
    root.querySelectorAll('video').forEach(function (v) { v.pause(); });
    lbState = { root: root, medias: medias, i: i, focus: document.activeElement };
    lbV.muted = false; sndState();
    lb.hidden = false; document.documentElement.classList.add('kk-ugcx-open');
    load(i);
    lb.querySelector('.kk-ugcx__close').focus({ preventScroll: true });
  }
  function closeLb() {
    if (!lbState) return;
    var s = lbState; lbState = null;
    lbV.pause(); lbV.innerHTML = ''; lbV.removeAttribute('src'); lbV.load();
    lb.hidden = true; document.documentElement.classList.remove('kk-ugcx-open');
    if (s.root.open) s.root.querySelectorAll('video').forEach(function (v) { var r = v.getBoundingClientRect(); if (r.right > 0 && r.left < window.innerWidth) play(v); });
    if (s.focus && s.focus.focus) s.focus.focus({ preventScroll: true });
  }
  function all() { document.querySelectorAll('[data-kk-ugc]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', all);
})();
                